import { all_routes } from "../../../../feature-module/router/all_routes";

export const recruiterSidebarData = [
    {
        title: "Dashboard",
        icon: "isax isax-grid-35",
        route: all_routes.recruiterDashboard,
    },
    {
        title:'Programs & Schools',
        icon:'fa-solid fa-magnifying-glass-plus',
        route: all_routes.allProgramsGrid
    },
    {
        title: "Students",
        icon: "fa-solid fa-user",
        route: all_routes.recruiterStudents,
    },
    {
        title: "Account Managers",
        icon: "fa-solid fa-users-gear",
        route: all_routes.recruiterAccountManagers,
        recruiterOnly: true,
    },
    {
        title: "Applications",
        icon: "isax isax-teacher5",
        route: all_routes.recruiterApplications,
    },
];